// 图表类型线性图标（与墨得大纲页一致）
const ChartIcon = ({ children, size = 20, className = '' }) => (
    <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        className={className}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
    >
        {children}
    </svg>
);

export const LineChartIcon = (props) => (
    <ChartIcon {...props}>
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </ChartIcon>
);

export const SurfaceChartIcon = (props) => (
    <ChartIcon {...props}>
        <path d="M2 12c0-4 4-8 10-8s10 4 10 8-4 8-10 8-10-4-10-8z" />
        <path d="M2 12c5 3 15-3 20 0" />
        <path d="M12 4v16" />
    </ChartIcon>
);

export const PieChartIcon = (props) => (
    <ChartIcon {...props}>
        <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
        <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </ChartIcon>
);

export const BarChartIcon = (props) => (
    <ChartIcon {...props}>
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
    </ChartIcon>
);

export const ScatterChartIcon = (props) => (
    <ChartIcon {...props}>
        <circle cx="8" cy="8" r="1.5" />
        <circle cx="16" cy="6" r="1.5" />
        <circle cx="12" cy="14" r="1.5" />
        <circle cx="18" cy="18" r="1.5" />
        <circle cx="6" cy="18" r="1.5" />
        <path d="M3 21h18" />
        <path d="M3 3v18" />
    </ChartIcon>
);

export const BoxChartIcon = (props) => (
    <ChartIcon {...props}>
        <line x1="12" y1="2" x2="12" y2="6" />
        <line x1="12" y1="18" x2="12" y2="22" />
        <rect x="8" y="6" width="8" height="12" />
        <line x1="8" y1="12" x2="16" y2="12" />
        <line x1="9" y1="2" x2="15" y2="2" />
        <line x1="9" y1="22" x2="15" y2="22" />
    </ChartIcon>
);

export const FlowchartIcon = (props) => (
    <ChartIcon {...props}>
        <rect x="3" y="4" width="6" height="6" />
        <rect x="15" y="4" width="6" height="6" />
        <rect x="9" y="14" width="6" height="6" />
        <path d="M6 10v6a2 2 0 0 0 2 2h1" />
        <path d="M18 10v4a2 2 0 0 1-2 2h-1" />
    </ChartIcon>
);

export const MindMapIcon = (props) => (
    <ChartIcon {...props}>
        <circle cx="12" cy="12" r="3" />
        <path d="M12 9V3" />
        <path d="M12 15v6" />
        <path d="M15 12h6" />
        <path d="M9 12H3" />
        <path d="M14.5 9.5 19 5" />
        <path d="M9.5 14.5 5 19" />
    </ChartIcon>
);

export const OrgChartIcon = (props) => (
    <ChartIcon {...props}>
        <rect x="9" y="3" width="6" height="5" />
        <rect x="2" y="16" width="6" height="5" />
        <rect x="16" y="16" width="6" height="5" />
        <path d="M12 8v4" />
        <path d="M5 12h14" />
        <path d="M5 12v4" />
        <path d="M19 12v4" />
    </ChartIcon>
);

export const UseCaseIcon = (props) => (
    <ChartIcon {...props}>
        <circle cx="5" cy="7" r="2" />
        <path d="M5 9v6" />
        <path d="M3 11h4" />
        <path d="M3 19l2-4 2 4" />
        <ellipse cx="16" cy="12" rx="6" ry="4" />
    </ChartIcon>
);

export const ClassDiagramIcon = (props) => (
    <ChartIcon {...props}>
        <rect x="4" y="2" width="16" height="20" rx="2" />
        <line x1="4" y1="8" x2="20" y2="8" />
        <line x1="4" y1="16" x2="20" y2="16" />
    </ChartIcon>
);

export const StateDiagramIcon = (props) => (
    <ChartIcon {...props}>
        <rect x="3" y="6" width="8" height="12" rx="2" />
        <rect x="15" y="8" width="6" height="8" rx="2" />
        <path d="M11 12h4" />
        <path d="M13 10l2 2-2 2" />
    </ChartIcon>
);

export const SequenceDiagramIcon = (props) => (
    <ChartIcon {...props}>
        <rect x="4" y="2" width="4" height="4" />
        <rect x="16" y="2" width="4" height="4" />
        <line x1="6" y1="6" x2="6" y2="22" strokeDasharray="2 2" />
        <line x1="18" y1="6" x2="18" y2="22" strokeDasharray="2 2" />
        <line x1="6" y1="12" x2="18" y2="12" />
        <path d="M16 10l2 2-2 2" />
    </ChartIcon>
);

export const NetworkDiagramIcon = (props) => (
    <ChartIcon {...props}>
        <circle cx="12" cy="5" r="2" />
        <circle cx="5" cy="19" r="2" />
        <circle cx="19" cy="19" r="2" />
        <path d="M12 7l-5.5 10.5" />
        <path d="M12 7l5.5 10.5" />
        <path d="M7 19h10" />
    </ChartIcon>
);
